import React from "react";
import { Card } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import moment from "moment";
import "./passCard.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileSignature, faUser } from "@fortawesome/free-solid-svg-icons";
import { faCalendar } from "@fortawesome/free-regular-svg-icons";

const PurchasedPassCard = (props) => {
    const { t } = useTranslation();
    const { pass } = props;

    return (
        <Card id={`passCard`} className="shadow-sm pass-card">
            <Card.Body>
                <p className="d-inline-block pass-title mb-0">{pass.pass_name}</p>
                <p className="d-inline-block float-end pass-price mb-0">
                    {pass.up_price.toFixed(2).toString().replace(".", ",")} {t("currency")}
                </p>
                <p className="mb-2 mt-3">
                    <FontAwesomeIcon icon={faFileSignature} className="me-1 me-lg-2" />
                    {pass.order_number}
                </p>
                <p className="mb-2">
                    <FontAwesomeIcon icon={faCalendar} className="me-1 me-lg-2" />
                    {moment(pass.up_purchase_date).format("YYYY-MM-DD")}
                </p>
                <p className="mb-2">
                    <FontAwesomeIcon icon={faUser} className="me-2" />
                    <strong>{pass.buying_user_name}</strong>
                </p>
                <p className="mb-0">
                    {t("payments.toPay")}:{" "}
                    <strong>
                        {(pass.up_price.toFixed(2) - pass.up_paid.toFixed(2)).toFixed(2).toString().replace(".", ",")} {t("currency")}
                    </strong>
                </p>
            </Card.Body>
        </Card>
    );
};

export default PurchasedPassCard;
